"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SelectV2", {
  enumerable: true,
  get: function get() {
    return _Select2["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select["default"];
  }
});
var _Select = _interopRequireDefault(require("./Select"));
var _Select2 = _interopRequireDefault(require("./v2/Select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }